/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_LowInputs */

const en_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const fr_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible`)
};

const de_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrig`)
};

const it_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basso`)
};

const ru_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Низкий`)
};

const es_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajo`)
};

const zh_cn2_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低的`)
};

const ja_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低い`)
};

const hi_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कम`)
};

const pt_pt2_manual_qc_priority_low = /** @type {(inputs: Manual_Qc_Priority_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixo`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Manual_Qc_Priority_LowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_low = /** @type {((inputs?: Manual_Qc_Priority_LowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_LowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_priority_low(inputs)
	if (locale === "de") return de_manual_qc_priority_low(inputs)
	if (locale === "it") return it_manual_qc_priority_low(inputs)
	if (locale === "ru") return ru_manual_qc_priority_low(inputs)
	if (locale === "es") return es_manual_qc_priority_low(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_priority_low(inputs)
	if (locale === "ja") return ja_manual_qc_priority_low(inputs)
	if (locale === "hi") return hi_manual_qc_priority_low(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_priority_low(inputs)
	return en_manual_qc_priority_low(inputs)
});